import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import Description from './description';
import MySubmit from './my-submit';

const AssignmentInfo = () => {
  return (
    <div className="flex justify-center flex-col items-center gap-4">
      <Tabs defaultValue="mySubmit" className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="mySubmit">내 제출</TabsTrigger>
          <TabsTrigger value="description">정답&해설보기</TabsTrigger>
        </TabsList>
        <TabsContent value="mySubmit" className="space-y-4">
          <MySubmit />
        </TabsContent>
        <TabsContent value="description" className="space-y-4">
          <Description />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AssignmentInfo;
